<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <div class="row">
            <div class="col-12">
                <div class="form-group mt-2">
                    <label class="text-left" for="descuento_porcentaje">Descuento en %</label>
                    <ValidationProvider name="descuento_porcentaje" id="descuento_porcentaje">
                        <select class="form-control" name="descuento_porcentaje" v-model="descuento_porcentaje">
                            <option value="0">Sin descuento</option>
                            <template v-for="(descuento, index) in configuracion.descuento_aplicado">
                                <option :key="index" :value="descuento.valor">{{ descuento.label }}</option>
                            </template>
                        </select>
                    </ValidationProvider>
                </div>

                <div class="form-group mt-2">
                    <label class="text-left" for="descuento_euro">Descuento en €</label>
                    <ValidationProvider name="descuento_euro" id="descuento_euro">
                        <input type="text" placeholder="Descuento en €" class="form-control" v-model="descuento_integro"/>
                    </ValidationProvider>
                </div>

                <div class="text-center">
                    <h5 class="p-2">
                        Importe a pagar: <h3>{{ importe_con_descuento | formatear_precio }}</h3>             
                    </h5>
                </div>

                <div class="row">
                    <div class="col-12 text-center">
                        <Button type="submit" name="button" class="mr-1">Descontar</Button>
                        <Button type="button" name="button" @click="close">Cancelar</Button>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        props: ['importe'],
        data() {
            return {
                descuento_porcentaje: 0,
                descuento_integro: 0
            }
        },
        methods: {
            descontar() {
                this.$emit('descontado', this.descuento_integro, this.descuento_porcentaje);
            },
            close() {
                this.$emit('close', 'descuento-plazo-' + this.plazo_id);
            },
            async submit() {
                var isValid = await this.$refs.observer.validate();

                if(this.importe_con_descuento < 0) {
                    isValid = false;
                }

                if (isValid) {
                    this.descontar();
                } else {
                    this.$toast.error('El importe no puede ser negativo');
                    this.close();
                    return;
                }
            },
        },
        computed: {
            configuracion() {
                return this.$store.getters.getConfig;
            },
            importe_con_descuento() {
                let importeFinal = this.importe;

                if (this.descuento_porcentaje != 0) {
                    const porcentaje = (100 - this.descuento_porcentaje) / 100;
                    importeFinal *= porcentaje;
                } else if (this.descuento_integro != 0) {
                    importeFinal -= this.descuento_integro;
                }

                return importeFinal;
            }
        },
        watch: {
            descuento_porcentaje() {
                if(this.descuento_porcentaje != 0) {
                    this.descuento_integro = 0;
                }
            },
            descuento_integro() {
                if(this.descuento_integro != 0) {
                    this.descuento_porcentaje = 0;
                }
            }
        },
    }
</script>